var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramCards64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Cards64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(5.000000, 15.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 54,
    height: 34,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,-8.8817842e-16 L51,0 C52.6568542,-3.04359188e-16 54,1.34314575 54,3 L54,31 C54,32.6568542 52.6568542,34 51,34 L43,34 L26,17 L43,-8.8817842e-16 Z",
    id: "focus",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "brand",
    fill: "#FFFFFF",
    points: "10 6 14 10 10 14 6 10.0356697"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramCards64);
export default __webpack_public_path__ + "static/media/pictogramCards64.b91fe034232efd8273b5a08e604d742d.svg";
export { ForwardRef as ReactComponent };